<template>
  <div class="hp-userinfo consult-index-user-info">
    <div class="userinfo-inner">
      <div class="info-top">
        <img
          :src="basicInfo.avatar | imgZip(140)"
          alt=""
          class="top-avatar"
          @click="showImgViewer"
        />
        <div class="top-basic">
          <div class="name">
            {{ basicInfo.nickname }}
          </div>
          <div
            v-if="isSelf && $platform.isYixinliApp"
            class="edit"
            @click="onEditClick"
          >
            <img
              src="~images/platform/homepage/ic-edit.png"
              alt=""
              class="edit-img"
            />
            <span class="edit-text">编辑</span>
          </div>
          <div class="btn-list" v-if="isShowBtnList && !isSelf">
            <p class="btn-base btn-letter" @click="sendLetter">私信</p>
            <p
              class="btn-base"
              :class="[hasFollow ? 'btn-has-follow' : 'btn-follow']"
              @click="toggleFollow"
            >
              <template v-if="hasFollow">
                <span>已关注</span>
              </template>
              <template v-else>
                <img
                  src="~images/platform/homepage/nm-follow-add-btn.png"
                  alt=""
                />
                <span>关注</span>
              </template>
            </p>
          </div>
        </div>
      </div>
      <div class="vip-box" v-if="vipList.length">
        <template v-if="vipList.length">
          <img
            v-for="(item, index) in vipList"
            :key="index"
            :src="item.image | imgZip(54)"
            :alt="item.name"
          />
        </template>
      </div>
      <div class="level-and-tags">
        <div class="tag-list-wrap" v-if="parsedLevel || tagList.length">
          <ul class="tag-list">
            <li
              class="parsed-level tag not-zx-tag"
              v-if="parsedLevel"
              @click="toLevelExplain"
            >
              {{ parsedLevel.level_name }}
            </li>

            <li
              class="tag not-zx-tag"
              v-for="tag in tagList"
              :key="tag.name"
              @click="onTagClick(tag)"
            >
              <p>{{ tag.name }}</p>
            </li>
          </ul>
        </div>
      </div>
      <yxlMore
        class="consult-index-more"
        v-if="basicInfo.brief"
        :lineClamp="2"
        :info="basicInfo.brief"
        @hook:updated="yxlMoreUpdated"
        @setShowAllCallback="setShowAllCallback"
      ></yxlMore>

      <div class="brief" v-else>
        <template v-if="isSelf">
          <span v-if="!isApp">你还没填写简介呢。</span>
          <span v-else
            >填写简介更容易获得大家的关注。
            <!-- <span class="link" @click="handleToConfig"> 点击添加</span> -->
          </span>
        </template>
        <span v-else>ta还没填写简介呢。</span>
      </div>
    </div>

    <ul class="num-block-list-box not-zx">
      <li class="block" v-for="(item, index) in blocks" :key="index">
        <p class="block-top DharmaTypeBebasKai" v-html="item.label"></p>
        <p class="block-bottom" v-html="item.name"></p>
      </li>
    </ul>
  </div>
</template>

<script>
import yxlMore from 'component/common/yxlMore.vue'
import { genCustomFonts, userInfoShowAllStat } from 'utils/homepageUtil.js'

export default {
  components: {
    yxlMore
  },
  data() {
    return {
      info: `国家二级心理咨询师、精神动力学取向咨询精神动力学取咨询、神动力学取向咨询精神动力学取咨询、国家二级心理咨询师国家二级心理咨询师、精神动力学取向咨询精神动力学取咨询、神动力学取向咨询精神动力学取咨询、国家二级心理咨询师`
    }
  },
  computed: {
    userinfo() {
      return this.$store.state.userinfo
    },
    loginUser() {
      return this.$store.getters['loginUser']
    },
    isOwner() {
      return +this.loginUser.id === +this.$route.params.userId
    },
    isShowBtnList() {
      // get-user-header还未发出，先不显示按钮
      if (!this.userinfo) {
        return false
      }
      // get-user-header已发出，当前访客未登录
      if (Array.isArray(this.userinfo)) {
        return true
      }
      // get-user-header已发出，当前访客已登录
      return !this.isOwner
    },

    userRelation() {
      return this.$store.state.homepage.userRelation
    },
    // 是否已关注
    hasFollow() {
      return this.userRelation && +this.userRelation.follow === 1
    },

    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    parsedLevel() {
      return this.$store.getters['homepage/parsedLevel']
    },
    tagList() {
      const { identities } = this.basicInfo
      let arr = Array.isArray(identities) ? identities : []
      return arr.slice(0, 3)
    },
    vipList() {
      const { vip } = this.basicInfo
      return Array.isArray(vip) ? vip : []
    },
    blocks() {
      const { achieve_count = {} } = this.basicInfo
      const {
        influence_num = 0,
        praise_num = 0,
        follow_num = 0,
        fans_num = 0
        // study_score = 0
      } = achieve_count
      return [
        {
          name: `浪花值`,
          get label() {
            return genCustomFonts(influence_num)
          }
        },
        {
          name: `获赞`,
          get label() {
            return genCustomFonts(praise_num)
          }
        },
        {
          name: `关注`,
          get label() {
            return genCustomFonts(follow_num)
          }
        },
        {
          name: `粉丝`,
          get label() {
            return genCustomFonts(fans_num)
          }
        }
        // {
        //   name: `鲸选学分`,
        //   get label() {
        //     return genCustomFonts(study_score)
        //   }
        // }
      ]
    },
    isSelf() {
      const { userinfo, homepage } = this.$store.state
      return userinfo?.id === homepage?.basicInfo?.id
    },
    isApp() {
      return this.$platform.isYixinliApp
    }
  },
  methods: {
    yxlMoreUpdated() {
      this.$emit('updated')
    },
    setShowAllCallback(showall) {
      userInfoShowAllStat.call(this, showall)
    },
    onTagClick() {
      this.$trackEvent('newprofilepages_certificationtags', {})
      this.routerToStaic({
        path: '/identify/index',
        query: {
          id: this.$route.params.userId,
          hideNavigationBar: 1
        }
      })
    },
    toLevelExplain() {
      this.$trackEvent('newprofilepages_levellabel', {})
      this.routerPushWithoutNav(`/growthCenter/levelExplain`)
    },
    sendLetter() {
      this.$emit('letter')
    },
    toggleFollow() {
      this.$emit('follow')
    },
    handleToConfig() {
      this.$trackEvent('newprofilepages_addabrief', {})
      window.location.href = 'yixinli://open_edit_info'
    },
    showImgViewer() {
      this.$trackEvent('newprofilepages_avatar', {})
      this.$emit('showImgViewer')
    },
    onEditClick() {
      window.location.href = 'yixinli://open_edit_info'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';
@import '~style/platform/homepage/userinfo.scss';

.w100 {
  width: 100%;
}
.consult-index-user-info {
  margin-top: -74px;
  .info-top {
    display: flex;
    align-items: flex-end;
    .top-avatar {
      width: 140px;
      height: 140px;
      border-radius: 50%;
      object-fit: cover;
      border: 1px solid #ffffff;
      z-index: 2;
      margin-right: 20px;
    }
    .top-basic {
      display: flex;
      align-items: flex-end;
      margin-bottom: 21px;
      width: calc(10rem - 224px);
      .name {
        font-size: 38px;
        height: 38px;
        max-width: 240px;
        @include limitLine(1);
      }
      .btn-list {
        margin-left: auto;
        .btn-letter {
          color: #6982fa;
          border-radius: 27px;
          border: 2px solid #6982fa;
        }
      }
    }
    .name {
      font-size: 38px;
      line-height: 38px;
      font-weight: 600;
      color: #21252d;
    }
  }

  .vip-box {
    flex-grow: 0;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-top: 30px;
    img {
      width: 72px;
      height: auto;
      object-fit: cover;
      margin-right: 10px;
    }
  }
  .tag-list {
    margin-top: 20px;
  }

  .parsed-level {
    font-size: 20px !important;
    max-width: 160px;
    @include limitLine(1);
  }

  .brief {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #9da3ac;
    line-height: 36px;
    margin-top: 30px;
    .link {
      color: #6982fa;
    }
  }

  .edit {
    display: flex;
    align-items: center;
    margin-left: auto;
    &-img {
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }
    &-text {
      font-size: 28px;
      line-height: 32px;
      color: #6982fa;
    }
  }

  .num-block-list-box {
    display: flex;
    align-items: center;
    width: 686px;
    height: 154px;
    background: #ffffff;
    box-shadow: 0px 0px 40px 0px #ebefff;
    border-radius: 30px;
    margin: 40px auto 20px;
    .block {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      flex: 1;
      position: relative;
      .block-top {
        font-size: 34px;
        font-family: BebasKai;
        font-weight: 400;
        color: #21252d;
        margin-bottom: 20px;
        height: 34px;
        ::v-deep .bb-num {
          color: #21252d;
        }
      }
      .block-bottom {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9da3ac;
      }
      &:not(:last-child)::after {
        content: '';
        width: 1px;
        height: 24px;
        background-color: #eaeaea;
        position: absolute;
        bottom: 6px;
        right: 0;
      }
    }
  }
  ::v-deep.consult-index-more {
    margin-top: 30px;
    .text {
      font-size: 24px !important;
      color: #6c798c !important;
    }
  }
}
</style>
